<ng-container *ngIf="hasRecentSearches$ | async">
  <div class="recentSearches__cont">
    <div class="recentSearches__header">
      <app-ds-typography
        [size]="fontSize.RG"
        [fontFamily]="fontFamily.SemiBold"
        [text]="'HOME_MODULE.RECENT_SEARCHES' | transloco"
        [color]="fontColor.Primary">
      </app-ds-typography>
      <div class="recentSearches__header-clear">
        <app-ds-button-link
          [type]="buttonLinkType"
          [fontSize]="fontSize.XXS"
          [label]="'HOME_MODULE.RECENT_SEARCHES_CLEAR' | transloco"
          (clickEvent)="deleteSearches()">
        </app-ds-button-link>
      </div>
    </div>
    <div class="recentSearches__slider">
      <app-slide-recent
        [isMobile]="isMobile$ | async"
        [searches]="recentSearches$ | async"
        [index]="index">
      </app-slide-recent>
    </div>
  </div>
</ng-container>